import {BookingState} from "../../../../../api/api";
import styled from "styled-components";


export const BookingStateBadge = ({state, isFixedAppointment}: {state?: BookingState, isFixedAppointment?: boolean}) => {
    const orange_light = '#FFBB89';
    const yellow = '#FFEE52';
    const green_light = '#79C240';
    const red = '#DC4040';
    const green_dark = '#60935D';
    
    
    if(state === BookingState.Planned) {
        return <Badge><ColorTile color={orange_light}/>&nbsp; Planlagt {isFixedAppointment ? '(aftale)' : ''}</Badge>
    } else if(state === BookingState.OnRoute) {
        return <Badge><ColorTile color={yellow}/>&nbsp; På rute</Badge>
    } else if(state === BookingState.OnGoing) {
        return <Badge><ColorTile color={green_light}/>&nbsp; I gang</Badge>
    } else if(state == BookingState.Complete){
        return <Badge><ColorTile color={green_dark}/>&nbsp; Færdig</Badge>
    } else {
        return <Badge><ColorTile color={red}/>&nbsp; Ukendt</Badge>
    }
}

const Badge = styled.div`
    font-size: 12px;
    display: inline-flex;
    flex-direction: row;
    margin: 7px;
`;

const ColorTile = styled.div<{ color: string }>`
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: ${(props) => props.color};
`;